import ThemeSwitch from "./ThemeSwitch";
import { useChatbot } from "../Context/ChatBotContext";
import React from 'react';

const Spotify = () => {
  return (
    <div className="min-h-20 w-[84%] md:w-96  bg-light-primary dark:bg-dark-primary rounded-full text-light-primary-text dark:text-dark-primary-text flex flex-row gap-2 px-6 items-center">
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20.5013 0.0664062C9.48964 0.0664062 0.5625 8.99331 0.5625 20.005C0.5625 31.0171 9.48964 39.9433 20.5013 39.9433C31.5142 39.9433 40.4404 31.0171 40.4404 20.005C40.4404 8.99403 31.5142 0.0673586 20.5011 0.0673586L20.5013 0.0664062V0.0664062ZM29.6451 28.8236C29.56 28.963 29.4483 29.0842 29.3163 29.1804C29.1843 29.2766 29.0346 29.3458 28.8758 29.3841C28.717 29.4223 28.5522 29.4289 28.3909 29.4034C28.2296 29.3779 28.0748 29.3208 27.9356 29.2355C23.2542 26.3759 17.3608 25.7283 10.4204 27.314C10.099 27.3871 9.76174 27.3296 9.48275 27.1541C9.20375 26.9787 9.00584 26.6996 8.9325 26.3783C8.89597 26.2192 8.89119 26.0545 8.91842 25.8935C8.94565 25.7326 9.00436 25.5786 9.09118 25.4404C9.17801 25.3021 9.29126 25.1824 9.42443 25.088C9.5576 24.9936 9.70808 24.9264 9.86726 24.8902C17.4625 23.1543 23.9775 23.9021 29.2332 27.114C29.8189 27.4736 30.0046 28.2378 29.6451 28.8236V28.8236ZM32.0856 23.3938C31.6356 24.1259 30.6785 24.3569 29.9475 23.9069C24.588 20.6119 16.4182 19.6578 10.0789 21.5821C9.25679 21.8305 8.38845 21.3671 8.13893 20.5464C8.01986 20.1518 8.06213 19.7262 8.25647 19.3627C8.4508 18.9993 8.78134 18.7277 9.1756 18.6076C16.4168 16.4105 25.4189 17.4747 31.5737 21.2569C32.3046 21.7069 32.5356 22.664 32.0856 23.394V23.3938ZM32.2951 17.7405C25.8689 13.9236 15.2665 13.5726 9.13107 15.4347C8.14583 15.7335 7.10393 15.1774 6.80536 14.1921C6.66179 13.7188 6.71209 13.2078 6.94521 12.7715C7.17832 12.3353 7.57515 12.0094 8.04845 11.8657C15.0915 9.7276 26.7999 10.1407 34.1985 14.5328C34.4093 14.6576 34.5935 14.8227 34.7404 15.0187C34.8874 15.2147 34.9942 15.4378 35.0548 15.6752C35.1154 15.9126 35.1286 16.1596 35.0936 16.4021C35.0586 16.6446 34.9761 16.8778 34.8508 17.0883C34.327 17.9745 33.1794 18.2666 32.2961 17.7405H32.2951Z"></path>
      </svg>
      <div className="flex flex-col ">
        <div className="opacity-70">{"On repeat"}</div>
        <a
          href="https://open.spotify.com/track/70eFcWOvlMObDhURTqT4Fv?si=d893469a0aef434e"
          className="font-semibold"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={"Spotify song - Beautiful People"}
        >
          {"Beautiful People"}
        </a>
      </div>
    </div>
  );
};

const Footer = () => {
  const { isChatbotEnabled, disableChatbot, enableChatbot } = useChatbot();
  const socialLinks = [
    { type: "GitHub", url: "https://github.com/pvinoda" },
    { type: "Instagram", url: "https://www.instagram.com/pvbcodejourney/" },
    { type: `𝕏`, url: "https://x.com/VbPrabhanjan" },
    { type: "Linkedin", url: "https://www.linkedin.com/in/prabhanjanvb/" },
    { type: "CV", url: "/PrabhanjanResume.pdf" },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-screen h-auto my-10">
      <div className="flex md:flex-row flex-col items-center md:gap-20 lg:gap-28 xl:gap-32 2xl:gap-36 gap-10 place-content-center">
        <div className="flex flex-col gap-8 md:items-start items-center md:w-auto w-full">
          <Spotify />
          <div className="opacity-70 text-light-secondary-text dark:text-dark-secondary-text ">{`© ${currentYear} Prabhanjan Vinoda Bharadwaj`}</div>
        </div>
        <div className="flex flex-row gap-20 md:w-auto w-full md:justify-center justify-around ">
          <div className="flex flex-col">
            <div className="font-semibold mb-10 text-light-secondary-text dark:text-dark-secondary-text text-xl">
              Explore
            </div>
            <div className="flex flex-col gap-5 text-light-secondary-text dark:text-dark-secondary-text opacity-70">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  aria-label={link.type}
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline underline-offset-2 "
                >
                  {link.type}
                </a>
              ))}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="font-semibold mb-10 text-light-secondary-text dark:text-dark-secondary-text text-xl">
              Contact
            </div>
            <div className="flex flex-col justify-between h-full">
              <div
                role="button"
                tabIndex={0}
                aria-label={"Message"}
                className="select-none flex flex-col gap-5 text-light-secondary-text dark:text-dark-secondary-text opacity-70 hover:underline underline-offset-2 cursor-pointer"
                onClick={isChatbotEnabled ? disableChatbot : enableChatbot}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    isChatbotEnabled ? disableChatbot() : enableChatbot();
                  }
                }}
              >
                {"Message"}
              </div>
              <ThemeSwitch />
            </div>
            <div className="flex self-center h-full -mb-10 w-[0.3em] bg-light-primary dark:bg-dark-primary"></div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
